import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import {DashboardPage} from './components/dashboard-page/dashboard-page';
import {MenuButton} from './components/menu-button/menu-button.component';
import { InfoPane } from './components/info-pane/info-pane.component';
import { LeadaComponentsModule } from 'shared/components';
import { ThreePane3 } from './components/lower-panel/three-pane-3/three-pane-3.component';
import { TwoPaneCont } from './components/lower-panel/two-pane-cont/two-pane-cont.component';
import { ThesesPane2 } from './components/lower-panel/theses-pane-2/theses-pane-2.component';

@NgModule({
  declarations: [
    DashboardPage,
    MenuButton,
    InfoPane,
    ThreePane3,
    TwoPaneCont,
    ThesesPane2
  ],
  imports: [
    CommonModule,
    IonicModule,
    SwiperModule,
    TranslateModule,
    LeadaComponentsModule,
    RouterModule.forChild([
      { path: '', component: DashboardPage },
    ]),
  ],
  providers: [],
  // entryComponents: [
  //   DashboardPage,
  // ],
})
export class DashboardModule { }
